module.exports = __webpack_public_path__ + "static/media/curlegance-5.3ebee92d.jpg";